import {
  isFrameSequence,
  isDragonBones,
  isCocosModelAnimationCategory,
} from '@/views/creative/utils'

export default {
  data() {
    return {
      renderLazyComponent: false,
    }
  },

  computed: {
    isImage() {
      return this.category.file_type === 'image'
    },

    isAudio() {
      return this.category.file_type === 'audio'
    },

    isVideo() {
      return this.category.file_type === 'video'
    },

    isImageLanguagePackage() {
      return this.isZip && this.category.prefix === 'lang'
    },

    isZip() {
      return this.category.file_type === 'zip'
    },

    isFrameSequence() {
      return isFrameSequence(this.category.prefix, this.category.resource_type)
    },

    isDragonBones() {
      return isDragonBones(this.category.prefix)
    },

    isModel() {
      return this.category.isModel
    },

    isCocosModelAnimation() {
      return isCocosModelAnimationCategory(this.category)
    },

    // 分类隐藏状态，为 true 时不渲染不必要的组件
    categoryVisible() {
      return !(
        this.category.properties &&
        typeof this.category.properties !== 'undefined' &&
        typeof this.category.properties.visible !== 'undefined' &&
        this.category.properties.visible === 2
      )
    },
  },

  mounted() {
    setTimeout(() => {
      this.renderLazyComponent = true
    }, 0)
  },
}
